import { render, staticRenderFns } from "./trigger_block.vue?vue&type=template&id=43fff0b2&"
import script from "./trigger_block.vue?vue&type=script&lang=js&"
export * from "./trigger_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "trigger_block.vue"
export default component.exports